import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { appTheme } from '../../../../src/theme';
import { GridItem } from '../Grid';

const SectionHeading = styled.h3`
  margin-bottom: 0;
  margin-top: calc(${appTheme.spacing.default} * 3);
`;

function FormSectionHeading({ children }) {
  return (
    <GridItem xs={12}>
      <SectionHeading>{children}</SectionHeading>
    </GridItem>
  );
}

FormSectionHeading.propTypes = {
  children: PropTypes.any,
};

export default FormSectionHeading;



// WEBPACK FOOTER //
// ./src/modules/common/form/FormSectionHeading.js